import { Field, InjectedFormProps, reduxForm } from 'redux-form';

import InputField from 'dashboard/components/FormControls/InputField';
import Form from 'dashboard/layouts/FormLayout/Form';
import Button from 'design-system/components/Button';
import { HStack } from 'design-system/components/Stack';
import { isMaxLength, isRequired, withMessage } from 'lib/utils/formValidation';

const validate = {
  name: [
    withMessage('Please enter a name', isRequired),
    withMessage('Please limit name to 255 characters', isMaxLength(255)),
  ],
};

interface FormRenameTransactionStatusProps {
  handleCancel: () => void;
}

const FormRenameTransactionStatus = ({
  handleCancel,
  handleSubmit,
  initialValues,
  pristine,
  submitting,
}: FormRenameTransactionStatusProps &
  InjectedFormProps<FormRenameTransactionStatusData, FormRenameTransactionStatusProps>) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Field
        label='Name'
        name='name'
        disabled={submitting}
        component={InputField}
        data-test='rename-transaction-status-form__name'
        validate={validate.name}
        placeholder={initialValues['name']}
      />
      <HStack>
        <Button
          id='rename-transaction-status-form__close'
          data-test='rename-transaction-status-form__close'
          name='rename-transaction-status-form__close'
          onClick={handleCancel}
          variant='basic'
        >
          Cancel
        </Button>
        <Button
          type='submit'
          data-test='rename-transaction-status-form__submit'
          name='rename-transaction-status-form__submit'
          value='Submit'
          disabled={pristine}
        >
          Rename
        </Button>
      </HStack>
    </Form>
  );
};

export interface FormRenameTransactionStatusData {
  name: string;
}

export default reduxForm<FormRenameTransactionStatusData, FormRenameTransactionStatusProps>({
  form: 'renameTransactionStatus',
})(FormRenameTransactionStatus);
